import { formatPrecisaoFloat } from "../../../utils";

export function tabProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const subtotalItem = (item) =>
  formatPrecisaoFloat(
    item.subtotal || item.quantidade * (item.valorUnitario || item.valor)
  );

export function totalItensLista(listaOrcamentosProdutos) {
  if (listaOrcamentosProdutos?.length) {
    const total = listaOrcamentosProdutos.reduce(
      (prevVal, elem) => formatPrecisaoFloat(prevVal + subtotalItem(elem)),
      0
    );
    return total;
  } else {
    return 0;
  }
}

export function calcularValorTotal(produto) {
  const total = parseFloat(produto?.valorUnitario) * produto?.quantidade;
  return total;
}

export function mapearEndereco(endereco) {
  return {
    ...endereco,
    cidade: endereco.cidade?.nome,
    codigoIbge: endereco.cidade?.codigoIbge,
    estado: endereco.cidade?.estado?.sigla,
    estadoId: endereco.cidade?.estadoId,
  };
}

export const mapearEnderecos = (enderecos, estados) => {
  return enderecos.map((endereco) => mapearEndereco(endereco, estados));
};

export function encontrarEnderecoPadrao(enderecos) {
  return enderecos.find((endereco) => endereco.padrao === true);
}

export function calcularPrecoProduto(
  produto,
  tabelaVenda = null,
  tipoTabela = null,
) {
  const preco = produto?.precoVenda || 0;
  if (tipoTabela === "meioPagamento" || tabelaVenda.tipoTabela === "POR_PRODUTO") {
    let tabelaVendaProduto = tabelaVenda;
    if (tabelaVenda?.itens?.length) {
      tabelaVendaProduto = tabelaVenda.itens.find(
        ({ estProdutoId }) =>
          estProdutoId === produto.id || estProdutoId === produto?.produtoId
      );
    }
    if (
      tabelaVendaProduto &&
      produto?.quantidade >= tabelaVendaProduto?.quantidadeMinima
    ) {
      const valorUnitario = formatPrecisaoFloat(
        tabelaVendaProduto.precoPraticado
      );
      return {
        ...produto,
        valorUnitario,
        totalItem: valorUnitario * (parseFloat(produto?.quantidade) || 1),
      };
    }
    return produto;
  } else {
    const porcentagem = formatPrecisaoFloat(tabelaVenda.fator / 100);
    const valorDescontoAcrescimo = formatPrecisaoFloat(preco * porcentagem);
    if (tabelaVenda.operacao === "subtrair") {
      return {
        ...produto,
        descontoPorcentagem: tabelaVenda.fator,
        desconto: valorDescontoAcrescimo,
        valorUnitario: preco,
      };
    } else {
      return {
        ...produto,
        despesas: valorDescontoAcrescimo,
        valorUnitario: preco,
      };
    }
  }
}

export function getIndexItemMaisCaro(lista) {
  return lista.reduce(
    (maxIndex, currentItem, currentIndex, array) =>
      subtotalItem(currentItem) > subtotalItem(array[maxIndex])
        ? currentIndex
        : maxIndex,
    0
  );
}

export function calculaSubtotalParaChave(lista, tipoOperacao, chave) {
  if (lista?.length > 0) {
    const valorCalculado = lista.reduce((acumulador, objetoAtual) => {
      return formatPrecisaoFloat(
        acumulador + parseFloat(objetoAtual[chave] ?? 0)
      );
    }, 0);
    return tipoOperacao !== chave ? valorCalculado : 0;
  }
}

export function calculoDesconto(itens, orcamento, porCemParaDecimal = true) {
  const total = totalItensLista(itens);
  let resultado;
  if (porCemParaDecimal) {
    const descontoPorcentagem = parseFloat(orcamento?.descontoPorcentagem ?? 0);
    resultado = (descontoPorcentagem / 100) * total;
    resultado = formatPrecisaoFloat(resultado, 3);
  } else {
    const desconto = parseFloat(orcamento?.desconto ?? 0);
    resultado = (desconto / formatPrecisaoFloat(total)) * 100;
    resultado = formatPrecisaoFloat(resultado, 3);
  }
  return resultado;
}

export function totalOrcamento(orcamentoItens, calculoTotalizadores) {
  const subtotalProdutos = totalItensLista(orcamentoItens);
  const subtotalDesconto = calculaSubtotalParaChave(
    orcamentoItens,
    calculoTotalizadores,
    "desconto"
  );
  const subtotalAcrescimo = calculaSubtotalParaChave(
    orcamentoItens,
    calculoTotalizadores,
    "acrescimo"
  );
  const subtotalDespesas = calculaSubtotalParaChave(
    orcamentoItens,
    calculoTotalizadores,
    "despesas"
  );
  return formatPrecisaoFloat(
    (subtotalProdutos || 0) -
      (subtotalDesconto || 0) +
      (subtotalAcrescimo || 0) +
      (subtotalDespesas || 0)
  );
}

export function formatProdutosTotalizadores(
  name,
  orcamentoItens,
  valueInputReal,
  totalNota
) {
  const valueInput = parseFloat(valueInputReal || 0);
  let listaAtualizada = orcamentoItens.map((item) => {
    const valorProporcional =
      formatPrecisaoFloat((subtotalItem(item) * 100) / totalNota) / 100;
    return {
      ...item,
      [name]:
        valueInput > 0
          ? formatPrecisaoFloat(valorProporcional * valueInput)
          : 0,
    };
  });
  ajustarDiferenca(name, valueInput, listaAtualizada);
  return listaAtualizada;
}

function ajustarDiferenca(key, valorTotal, listaAtualizada) {
  const subtotal = calculaSubtotalParaChave(listaAtualizada, "", key);
  if (valorTotal !== subtotal && valorTotal > 0 && subtotal > 0) {
    const indiceItemMaisCaro = getIndexItemMaisCaro(listaAtualizada);
    const diferenca = formatPrecisaoFloat(valorTotal - subtotal);
    listaAtualizada[indiceItemMaisCaro][key] += diferenca;
  }
}

export function limparCampoTotalizador(name, itens) {
  if (!itens?.length) return;
  return itens.map((item) => ({
    ...item,
    [name]: 0,
  }));
}

export function formatTotalItemAcrescimo(item, acrescimoPagamento) {
  const { quantidade, precoVenda } = item;
  const valorUnitarioAcrescimo =
    acrescimoPagamento
      ? precoVenda +
        formatPrecisaoFloat(
          precoVenda * (acrescimoPagamento / 100)
        )
      : precoVenda;
  return {
    valorUnitario: valorUnitarioAcrescimo,
    totalItem: valorUnitarioAcrescimo * quantidade
  }
}

export function validarTabelaVendaCliente(tabelaVenda, produtoId) {
  if (tabelaVenda) {
    return tabelaVenda.itens.length 
    ? tabelaVenda.itens.find(
        ({ estProdutoId }) => produtoId === estProdutoId
      )
    : null;
  }

  return false;
}

export function validarTabelaVendaMeioPagamento(tabelasVenda, meioPagamentoId) {
  if (tabelasVenda) {
    const tabelaVenda = tabelasVenda[0]?.tabelaVenda;
    return tabelaVenda?.meioPagamentoIds.length
      ? tabelaVenda?.meioPagamentoIds.find(
        ({ fatMeioPagamentoId }) => fatMeioPagamentoId === meioPagamentoId
      )
      : null;
  } 
  
  return false;
}

export function validarTabelaTodosProdutosMeioPagamento(tabelasVenda, meioPagamentoId) {
  if (tabelasVenda?.length > 0) {
    return tabelasVenda.find((tabela) => 
      tabela.meioPagamentoIds?.find(
        ({ fatMeioPagamentoId }) => fatMeioPagamentoId === meioPagamentoId)
      );
  }

  return false;
}